import { LanguageType } from "../../types";

const supportedLanguages = ["ko", "zh-HK", "zh-TW", "ja"] as const;

export default function isLanguageType(value: string): value is LanguageType {
  return supportedLanguages.includes(value as LanguageType);
}
